// 切换皮肤
import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
  useMemo,
  forwardRef,
} from "react";
import { injectIntl, useIntl } from "react-intl";
import { produce } from "immer";
import { useUserInfo } from "@/model/useUserInfo";
import styles from "@/components/switchTheme.style.js";
import { makeStyles } from "tss-react/mui";
import { useTheme } from "@mui/material/styles";
import CONST from "@/config/const";
import { usePageMode } from "@/model/usePageMode";
import arrow_down from "@/assets/svg/arrow_down.svg";
import radio_check from "@/assets/svg/radio-check.svg";
import country from "@/assets/svg/country.svg";

const useStyles = makeStyles()(styles);

let initState = {
  open: false,
};
const reducer = produce((draft, action = { paylod: {}, type: "@@INTT" }) => {
  const { type, payload } = action;
  switch (type) {
    default:
      Object.keys(payload).map((item) => {
        draft[item] = payload[item];
      });
  }
}, initState);
let timer = null;

const CopyRC = (props, ref) => {
  const intl = useIntl();
  const { classes, cx } = useStyles();
  const { lang, curr_rate, changeLang, changeRate, mode } = usePageMode();
  const { userinfo } = useUserInfo();
  const { isShowKorean } = userinfo;
  const { palette } = useTheme();
  const [isEnter, setIsEnter] = useState(false);

  const [state, dispatch] = useReducer(reducer, initState);

  const ref_dom = useRef(null);
  const langListFiltered = props.langArr || [];
  const rateListFiltered = props.rateArr || [];
  window._langList = langListFiltered.map((item) => item.id);
  const lang_text = langListFiltered.find((item) => item.id == lang);

  const change = (key, value) => () => {
    if (key == "lang") {
      changeLang(value);
    }
  };
  const rateChange = (key) => () => {
    changeRate(key);
  };
  const mouseEnter = () => {
    clearTimeout(timer);
    timer = null;
    setIsEnter(true);
  };
  const mouseLeave = () => {
    timer = setTimeout(() => {
      setIsEnter(false);
    }, 50);
  };
  return (
    <>
      <div
        className={classes.header_popover_btn}
        style={{ height: 24 }}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <div className={classes.switchlang} ref={ref_dom}>
          {/* <span>{lang_text?.name}</span>{" "} */}
          {/* <svg data-src={arrow_down} className={classes.g_svg_stroke} /> */}
          <svg data-src={country} width={24} height={24} />
        </div>
        <div
          className={cx("header_popover", isEnter ? classes.showPopover : "")}
          style={{
            right: 0,
            top: 23,
            width: 360,
            flexDirection: "row",
            gap: 10,
          }}
        >
          <ul className={classes.lang} style={{ width: 160 }}>
            <li className="lang">
              {intl.formatMessage({ id: "header.language" })}
            </li>
            {langListFiltered.map((item) => {
              return (
                <li
                  key={item.id}
                  className={item.id == lang ? "on" : ""}
                  onClick={change("lang", item.id)}
                >
                  {item.name}
                  {item.id == lang ? <svg data-src={radio_check} /> : ""}
                </li>
              );
            })}
          </ul>
          <ul className={classes.lang}>
            <li className="lang">
              {intl.formatMessage({ id: "header.rate" })}
            </li>
            {rateListFiltered.map((item) => {
              return (
                <li
                  key={item.langKey}
                  className={item.langKey == curr_rate ? "on" : ""}
                  onClick={rateChange(item.langKey)}
                >
                  {item.lang_coin} - {item.lang_logo}
                  {item.langKey == curr_rate ? (
                    <svg data-src={radio_check} />
                  ) : (
                    ""
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default forwardRef(CopyRC);
